import { useQuery } from "react-query";

interface NationalRate {
  id: string;
  date: string;
  source: string;
  rate: string;
  points: string | null;
  change: string | null;
  prior_year: string | null;
  yoy_change: string | null;
}

const API_BASE_URL = import.meta.env.VITE_API_BASE_URL;

export const useNationalRates = () => {
  return useQuery<{ rates: NationalRate[] }>(
    "nationalRates",
    async () => {
      const response = await fetch(`${API_BASE_URL}/national-rates`);
      if (!response.ok) {
        throw new Error("Failed to fetch national rates");
      }
      return response.json();
    },
    {
      // Data is considered fresh for 1 hour
      staleTime: 1000 * 60 * 60,
      // Cache the data for 24 hours
      cacheTime: 1000 * 60 * 60 * 24,
      // Don't refetch on window focus since rates don't change that frequently
      refetchOnWindowFocus: false,
      // Don't refetch on mount if we have cached data
      refetchOnMount: false,
    }
  );
};
